/* Antipest cart slider: opens from the cart icon and after add-to-cart; built from /cart.js, checks out at /checkout.
   Upsell carousel, shipping protection (29 kr, on by default) and trust blocks as in the source's slide cart. */
(function () {
  if (window.__cSlider) return;
  window.__cSlider = true;
  var PROTECTION = 'shipping-protection';
  var UPSELLS = ['critter-control-spray', 'mosquito-patches', 'spider-repellent-pouches'];
  var nativeFetch = window.fetch.bind(window);
  var MAIN = 'mouse-repellent-pouches', prevFree = 0, pendingAdd = false;
  var root, bodyEl, footEl, titleEl, busy = false, cartState = null, fixing = false, upIdx = 0, upData = null, protVariant = null;
  var fmt = function (c) { return new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 }).format(Math.round(c / 100)) + ' kr'; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); };
  var img = function (u) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200' : ''; };
  var optedOut = function () { try { return localStorage.getItem('ap_ship_optout') === '1'; } catch (e) { return false; } };
  var setOptOut = function (v) { try { if (v) localStorage.setItem('ap_ship_optout', '1'); else localStorage.removeItem('ap_ship_optout'); } catch (e) {} };
  var json = function (r) { return r.json(); };
  var post = function (url, body) { return nativeFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); };

  var STAR = '<svg viewBox="0 0 20 20" width="17" height="17" aria-hidden="true"><path d="M10 1.5l2.5 5.3 5.8.7-4.3 4 1.1 5.7L10 14.3l-5.1 2.9L6 11.5 1.7 7.5l5.8-.7z" fill="currentColor"/></svg>';
  var BOX = '<svg viewBox="0 0 48 48" width="40" height="40" aria-hidden="true"><path d="M6 14l18-8 18 8v20l-18 8-18-8z M6 14l18 8 18-8 M24 22v20" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="35" cy="34" r="9" fill="#fff" stroke="currentColor" stroke-width="2"/><path d="M35 28.5l4.5 1.8v3.4c0 2.6-1.9 4.3-4.5 5.3-2.6-1-4.5-2.7-4.5-5.3v-3.4z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
  var TRUCK = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M2 6h11v9H2zM13 9h4l3 3v3h-7zM6 18.2a1.7 1.7 0 100-.01M17 18.2a1.7 1.7 0 100-.01" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
  var PKG = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M3 7.5L12 3l9 4.5v9L12 21l-9-4.5zM3 7.5l9 4.5 9-4.5M12 12v9" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';

  // "Köp 2, få 1 gratis" / "Köp 3, få 2 gratis": the free packs are shown as their own line, the cart quantity stays the total
  var isFreeLine = function (it) { return it.handle === MAIN && /gratis påse/i.test(it.variant_title || ''); };
  var freeFor = function (paid) { return paid >= 3 ? 2 : paid >= 2 ? 1 : 0; };
  var freeVariant = null;
  function loadFreeVariant() {
    if (freeVariant) return Promise.resolve(freeVariant);
    return nativeFetch('/products/' + MAIN + '.js').then(json).then(function (p) { freeVariant = p.variants.filter(function (v) { return /gratis påse/i.test(v.title || ''); })[0]; return freeVariant; });
  }
  var freeOf = function (t) { return t >= 5 ? 2 : t >= 3 ? 1 : 0; };
  var totalFor = function (paid) { return paid <= 0 ? 0 : paid + (paid >= 3 ? 2 : paid >= 2 ? 1 : 0); };
  var GIFT = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M3 9h18v4H3zM5 13h14v8H5zM12 9v12M12 9c-2.5 0-4.5-1-4.5-2.7S9 3.5 10.5 4.5 12 9 12 9zm0 0c2.5 0 4.5-1 4.5-2.7S15 3.5 13.5 4.5 12 9 12 9z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';

  function mainHTML(it, free, subModel) {
    var paid = subModel ? it.quantity : it.quantity - free, line = it._line;
    var unit = it.original_price;
    var was = it.original_line_price > it.final_line_price;
    var variant = it.selling_plan_allocation ? '<p class="cs__variant">Prenumeration · leverans var 4:e vecka</p>' : '';
    var thumb = it.featured_image && it.featured_image.url ? '<img src="' + esc(img(it.featured_image.url)) + '" alt="' + esc(it.product_title) + '" width="72" height="72" loading="lazy">' : '';
    var up = subModel ? paid + 1 : totalFor(paid + 1), down = subModel ? paid - 1 : totalFor(paid - 1), attr = subModel ? 'data-cs-paid' : 'data-cs-qty';
    var html = '<li class="cs__item"><a class="cs__thumb" href="' + esc(it.url) + '">' + thumb + '</a>' +
      '<div class="cs__info"><p class="cs__name">' + esc(it.product_title) + '</p>' + variant +
      '<p class="cs__prices"><span class="cs__price">' + fmt(it.final_line_price) + '</span>' + (was ? ' <s class="cs__was">' + fmt(it.original_line_price) + '</s>' : '') + '</p>' +
      '<div class="cs__qty" role="group" aria-label="Antal"><button type="button" ' + attr + '="' + down + '" data-line="' + line + '" aria-label="Minska antal">−</button><span>' + paid + '</span><button type="button" ' + attr + '="' + up + '" data-line="' + line + '" aria-label="Öka antal">+</button></div></div>' +
      '<button type="button" class="cs__rm" ' + attr + '="0" data-line="' + line + '" aria-label="Ta bort"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v6M14 11v6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></button></li>';
    if (free > 0) {
      html += '<li class="cs__item cs__item--free' + (free > prevFree ? ' is-new' : '') + '"><span class="cs__ribbon">' + GIFT + ' GRATIS</span><a class="cs__thumb" href="' + esc(it.url) + '">' + thumb + '<i class="cs__plus">+' + free + '</i></a>' +
        '<div class="cs__info"><p class="cs__name">' + esc(it.product_title) + ' <span class="cs__x2">× ' + free + '</span></p>' +
        '<p class="cs__prices"><span class="cs__price cs__price--free">0 kr</span> <s class="cs__was">' + fmt(unit * free) + '</s></p>' +
        '<p class="cs__gift">🎁 ' + (free === 1 ? 'Din gratis påse – ingår i köpet!' : 'Dina ' + free + ' gratis påsar – ingår i köpet!') + '</p></div></li>';
    }
    return html;
  }
  function nudgeHTML(main, subModel) {
    if (!main) return '';
    var t = main.quantity;
    if (subModel ? t >= 3 : t >= 5) return '';
    var text = 'Lägg till <b>1 påse</b> – få <b>1 påse till GRATIS</b>';
    var btn = subModel ? 'data-cs-paid="' + (t + 1) + '"' : 'data-cs-qty="' + (t >= 3 ? 5 : 3) + '"';
    return '<div class="cs__nudge"><span class="cs__nudge-ic">🎁</span><p>' + text + '</p><button type="button" class="cs__nudge-btn" ' + btn + ' data-line="' + main._line + '">Lägg till</button></div>';
  }
  function confetti() {
    var host = root.querySelector('.cs__panel'); if (!host) return;
    var c = document.createElement('div'); c.className = 'cs__confetti'; c.setAttribute('aria-hidden', 'true');
    var cols = ['#769a2c', '#CCF46F', '#f5a623', '#ff6b8b', '#1d3a21'];
    for (var i = 0; i < 26; i++) { var p = document.createElement('i'); var a = Math.random() * Math.PI * 2, d = 90 + Math.random() * 150; p.style.cssText = 'background:' + cols[i % cols.length] + ';--dx:' + Math.round(Math.cos(a) * d) + 'px;--dy:' + Math.round(Math.sin(a) * d - 60) + 'px;--r:' + Math.round(Math.random() * 720 - 360) + 'deg;animation-delay:' + (Math.random() * 120) + 'ms'; c.appendChild(p); }
    host.appendChild(c); setTimeout(function () { c.remove(); }, 1400);
  }

  function build() {
    if (root) return;
    root = document.createElement('div');
    root.id = 'c-slider';
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML =
      '<div class="cs__overlay" data-cs-close></div>' +
      '<aside class="cs__panel" role="dialog" aria-modal="true" aria-label="Varukorg">' +
      '<header class="cs__head"><h2 class="cs__title">Varukorg</h2>' +
      '<button type="button" class="cs__x" data-cs-close aria-label="Stäng"><svg viewBox="0 0 18 18" width="22" height="22" aria-hidden="true"><path d="M2 2l14 14M16 2L2 16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg></button></header>' +
      '<div class="cs__body"></div><footer class="cs__foot"></footer></aside>';
    document.body.appendChild(root);
    bodyEl = root.querySelector('.cs__body');
    footEl = root.querySelector('.cs__foot');
    titleEl = root.querySelector('.cs__title');
    root.addEventListener('click', onClick);
  }

  function loadUpsells() {
    if (upData) return Promise.resolve(upData);
    return Promise.all(UPSELLS.map(function (h) {
      return nativeFetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (all) { upData = all.filter(Boolean); return upData; });
  }
  function loadProtection() {
    if (protVariant) return Promise.resolve(protVariant);
    return nativeFetch('/products/' + PROTECTION + '.js').then(json).then(function (p) { protVariant = p.variants[0]; return protVariant; });
  }

  // keep the protection line in step with the cart: exactly one while there is anything else in it (unless opted out)
  function settle(cart) {
    var prot = cart.items.filter(function (i) { return i.handle === PROTECTION; });
    var freeL = cart.items.filter(isFreeLine)[0];
    var subMain = cart.items.filter(function (i) { return i.handle === MAIN && !isFreeLine(i) && i.selling_plan_allocation; })[0];
    var rest = cart.items.length - prot.length - (freeL ? 1 : 0);
    var p, kind;
    if (freeL && !fixing && (!subMain || freeL.quantity !== freeFor(subMain.quantity))) {
      var want = subMain ? freeFor(subMain.quantity) : 0;
      kind = 'fix'; p = post('/cart/change.js', { id: freeL.key, quantity: want });
      fixing = true;
      return { kind: kind, p: p.then(function () { return nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(json); }).catch(function () { return cart; }).then(function (c) { fixing = false; return c; }) };
    }
    if (!freeL && subMain && freeFor(subMain.quantity) > 0 && !fixing) {
      fixing = true;
      return { kind: 'fix', p: loadFreeVariant().then(function (v) { return post('/cart/add.js', { items: [{ id: v.id, quantity: freeFor(subMain.quantity) }] }); }).then(function () { return nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(json); }).catch(function () { return cart; }).then(function (c) { fixing = false; return c; }) };
    }
    if (rest === 0 && prot.length) { kind = 'clear'; p = post('/cart/clear.js', {}); }
    else if (rest > 0 && !prot.length && !optedOut()) { kind = 'add'; p = loadProtection().then(function (v) { return post('/cart/add.js', { items: [{ id: v.id, quantity: 1 }] }); }); }
    else if (prot.length && prot[0].quantity !== 1) { kind = 'fix'; p = post('/cart/change.js', { id: String(prot[0].variant_id), quantity: 1 }); }
    if (!p || fixing) return null;
    fixing = true;
    return { kind: kind, p: p.then(function () { return nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(json); }).catch(function () { return cart; }).then(function (c) { fixing = false; pendingAdd = false; return c; }) };
  }

  function render(cart) {
    var fix = settle(cart);
    if (fix && fix.kind !== 'add') return fix.p.then(render);
    // the protection joins in the background; the cart is drawn right away as if it were already in
    if (fix) { pendingAdd = true; fix.p.then(render); }
    root && root.classList.remove('is-loading');
    cartState = cart;
    build();
    var items = cart.items.map(function (it, i) { it._line = i + 1; return it; });
    var prot = items.filter(function (i) { return i.handle === PROTECTION; })[0];
    var freeLine = items.filter(isFreeLine)[0];
    var products = items.filter(function (i) { return i.handle !== PROTECTION && !isFreeLine(i); });
    var n = products.reduce(function (s, i) { return s + i.quantity; }, 0) + (freeLine ? freeLine.quantity : 0);
    document.querySelectorAll('#cart-icon-bubble').forEach(function (a) {
      var b = a.querySelector('.cart-count-bubble');
      if (!n) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); }
      b.innerHTML = '<span aria-hidden="true">' + n + '</span><span class="visually-hidden">' + n + ' artiklar</span>';
    });
    if (!n) {
      bodyEl.innerHTML = '<div class="cs__empty"><p class="cs__empty-title">Din varukorg är tom</p><p class="cs__empty-text">Lägg till Antipest för att komma igång.</p><button type="button" class="cs__btn cs__btn--ghost" data-cs-close>Fortsätt handla</button></div>';
      footEl.innerHTML = '';
      footEl.hidden = true;
      return;
    }
    footEl.hidden = false;
    var mainItem = products.filter(function (i) { return i.handle === MAIN; })[0];
    var subModel = Boolean(mainItem && mainItem.selling_plan_allocation);
    var freeNow = !mainItem ? 0 : subModel ? (freeLine ? freeLine.quantity : 0) : freeOf(mainItem.quantity);
    var saved = !mainItem || !freeNow ? 0 : subModel ? mainItem.original_price * freeNow : Math.max(0, mainItem.original_line_price - mainItem.final_line_price);
    bodyEl.innerHTML = (freeNow ? '<div class="cs__win"><b>🎉 ' + (freeNow === 1 ? '1 påse GRATIS' : freeNow + ' påsar GRATIS') + '</b>' + (saved ? '<span>Du sparar ' + fmt(saved) + '</span>' : '') + '</div>' : '') + '<ul class="cs__items">' + products.map(function (it) {
      if (it.handle === MAIN) return mainHTML(it, freeNow, subModel);
      var line = it._line;
      var free = it.final_line_price === 0;
      var was = it.original_line_price > it.final_line_price && !free;
      var variant = it.selling_plan_allocation ? '<p class="cs__variant">Prenumeration · leverans var 4:e vecka</p>' : '';
      var price = free ? '<span class="cs__price">GRATIS</span>' : '<span class="cs__price">' + fmt(it.final_line_price) + '</span>' + (was ? ' <s class="cs__was">' + fmt(it.original_line_price) + '</s>' : '');
      return '<li class="cs__item"><a class="cs__thumb" href="' + esc(it.url) + '">' + (it.featured_image && it.featured_image.url ? '<img src="' + esc(img(it.featured_image.url)) + '" alt="' + esc(it.product_title) + '" width="72" height="72" loading="lazy">' : '') + '</a>' +
        '<div class="cs__info"><p class="cs__name">' + esc(it.product_title) + '</p>' + variant +
        '<p class="cs__prices">' + price + '</p>' +
        '<div class="cs__qty" role="group" aria-label="Antal"><button type="button" data-cs-qty="' + (it.quantity - 1) + '" data-line="' + line + '" aria-label="Minska antal">−</button><span>' + it.quantity + '</span><button type="button" data-cs-qty="' + (it.quantity + 1) + '" data-line="' + line + '" aria-label="Öka antal">+</button></div></div>' +
        '<button type="button" class="cs__rm" data-cs-qty="0" data-line="' + line + '" aria-label="Ta bort"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v6M14 11v6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></button></li>';
    }).join('') + '</ul>' + nudgeHTML(mainItem, subModel) + trustHTML();
    if (freeNow > prevFree) setTimeout(confetti, 120);
    prevFree = freeNow;
    renderFoot(cart, prot, products);
    loadUpsells().then(function () { renderUpsell(products); });
  }

  function trustHTML() {
    return '<div class="cs__trust">' +
      '<p class="cs__rev"><span class="cs__stars">' + STAR + STAR + STAR + STAR + STAR + '</span> 4,8 baserat på 14 932+ recensioner</p>' +
      '<div class="cs__guar"><span class="cs__badge"><b>30</b><small>DAGAR</small></span><div><p class="cs__guar-t">Prova helt riskfritt</p><p class="cs__guar-s">30 dagar på dig att se att det fungerar. Inte skadedjursfritt? Full återbetalning, inga frågor.</p></div></div>' + '</div>';
  }

  function renderFoot(cart, prot, products) {
    var on = Boolean(prot) || pendingAdd;
    var protPrice = prot ? prot.final_line_price : (protVariant ? protVariant.price : 2900);
    var total = cart.total_price + (!prot && pendingAdd ? protPrice : 0);
    footEl.innerHTML =
      '<div class="cs__up" data-cs-up hidden></div>' +
      '<div class="cs__prot"><span class="cs__prot-ic">' + BOX + '</span><span class="cs__prot-name">Fraktskydd</span><span class="cs__prot-price">' + fmt(protPrice) + '</span>' +
      '<button type="button" class="cs__sw' + (on ? ' is-on' : '') + '" role="switch" aria-checked="' + (on ? 'true' : 'false') + '" aria-label="Fraktskydd" data-cs-prot><i></i></button></div>' +
      '<div class="cs__total"><span>Delsumma</span><span>' + fmt(total) + '</span></div>' +
      '<a class="cs__btn cs__btn--primary" href="/checkout" data-cs-checkout>Gå till kassan</a>';
  }

  function renderUpsell(products) {
    var box = footEl.querySelector('[data-cs-up]');
    if (!box || !upData) return;
    var inCart = {};
    cartState.items.forEach(function (i) { inCart[i.handle] = true; });
    var list = upData.filter(function (p) { return !inCart[p.handle]; });
    if (!list.length) { box.hidden = true; return; }
    upIdx = ((upIdx % list.length) + list.length) % list.length;
    var p = list[upIdx];
    var v = p.variants[0];
    var im = (p.featured_image || '').replace(/^\/\//, 'https://');
    box.hidden = false;
    box.innerHTML = '<div class="cs__up-h"><h3>Maximera ditt skydd</h3>' + (list.length > 1 ? '<span><button type="button" data-cs-prev aria-label="Föregående">‹</button><button type="button" data-cs-next aria-label="Nästa">›</button></span>' : '') + '</div>' +
      '<div class="cs__up-c"><img src="' + esc(img(im)) + '" alt="' + esc(p.title) + '" width="52" height="52"><p class="cs__up-n">' + esc(p.title) + '<b>' + fmt(v.price) + '</b></p>' +
      '<button type="button" class="cs__add" data-cs-add="' + v.id + '">Lägg till</button></div>';
    box._list = list;
  }

  function refresh() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(json).then(render);
  }
  function open(skipRefresh) {
    build();
    if (skipRefresh !== true) refresh();
    show();
  }
  function show() {
    root.setAttribute('aria-hidden', 'false');
    root.classList.add('is-open');
    document.documentElement.classList.add('cs-lock');
    setTimeout(function () { var x = root.querySelector('.cs__x'); if (x) x.focus(); }, 50);
  }
  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cs-lock');
  }
  function run(p) {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');
    p().then(function () { return refresh(); }).catch(function () {})
      .then(function () { busy = false; root.classList.remove('is-busy'); document.dispatchEvent(new CustomEvent('cart:updated')); });
  }
  // subscription: the paid packs are one line (they renew), the free packs another, one-time line (they do not)
  function setSub(paid) {
    var items = cartState.items;
    var main = items.filter(function (i) { return i.handle === MAIN && !isFreeLine(i) && i.selling_plan_allocation; })[0];
    var fl = items.filter(isFreeLine)[0];
    if (!main) return Promise.resolve();
    var want = freeFor(paid);
    var chain = post('/cart/change.js', { id: main.key, quantity: paid });
    if (fl) chain = chain.then(function () { return post('/cart/change.js', { id: fl.key, quantity: want }); });
    else if (want > 0) chain = chain.then(function () { return loadFreeVariant().then(function (v) { return post('/cart/add.js', { items: [{ id: v.id, quantity: want }] }); }); });
    return chain;
  }
  function onClick(e) {
    var t = e.target;
    if (t.closest('[data-cs-close]')) return close();
    var pd = t.closest('[data-cs-paid]');
    if (pd) { var np = Math.max(0, Number(pd.getAttribute('data-cs-paid'))); return run(function () { return setSub(np); }); }
    var q = t.closest('[data-cs-qty]');
    if (q) { var line = q.getAttribute('data-line'), qty = Number(q.getAttribute('data-cs-qty')); return run(function () { return post('/cart/change.js', { line: Number(line), quantity: Math.max(0, qty) }); }); }
    if (t.closest('[data-cs-prot]')) {
      var on = footEl.querySelector('[data-cs-prot]').classList.contains('is-on');
      setOptOut(on);
      return run(function () {
        if (on) { var l = cartState.items.filter(function (i) { return i.handle === PROTECTION; })[0]; return l ? post('/cart/change.js', { id: String(l.variant_id), quantity: 0 }) : Promise.resolve(); }
        return loadProtection().then(function (v) { return post('/cart/add.js', { items: [{ id: v.id, quantity: 1 }] }); });
      });
    }
    var add = t.closest('[data-cs-add]');
    if (add) return run(function () { return post('/cart/add.js', { items: [{ id: Number(add.getAttribute('data-cs-add')), quantity: 1 }] }); });
    if (t.closest('[data-cs-next]')) { upIdx++; return renderUpsell(); }
    if (t.closest('[data-cs-prev]')) { upIdx--; return renderUpsell(); }
  }

  // the cart icon (and any link to /cart) opens the slider instead of the native cart page
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented && !(e.target.closest && e.target.closest('#cart-icon-bubble'))) return;
    var a = e.target.closest && e.target.closest('#cart-icon-bubble, a[href="/cart"], a[href^="/cart?"]');
    if (!a || (root && root.contains(a))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // add to cart: the button buzzes and the slider opens on the tap (with a skeleton while the cart answers) instead of seconds later
  function buzz(b) {
    b.classList.remove('ap-buzz'); void b.offsetWidth; b.classList.add('ap-buzz');
    try { if (navigator.vibrate) navigator.vibrate(14); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="add"], [data-add-to-cart]');
    if (!b || (root && root.contains(b))) return;
    buzz(b);
    build();
    if (!cartState || !cartState.items.length) {
      root.classList.add('is-loading');
      titleEl.textContent = 'Varukorg';
      bodyEl.innerHTML = '<div class="cs__skel"><i></i><div><b></b><b></b><b></b></div></div>';
      footEl.innerHTML = ''; footEl.hidden = true;
    }
    open(true);
  }, true);

  // after anything adds to the cart, show it; after other cart calls just keep the slider in step
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(window, arguments);
    if (!fixing && !busy && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      var isAdd = /\/cart\/add/.test(url);
      p.then(function (r) { if (r.ok) setTimeout(function () { if (!root || !root.classList.contains('is-open') || isAdd) { refresh().then(function () { if (isAdd) show(); }); } else refresh(); }, 80); }).catch(function () {});
    }
    return p;
  };

  function ready() { build(); refresh(); loadProtection().catch(function () {}); loadUpsells(); if (location.hash === '#cart') open(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
